(function () {
    'use strict';

    angular.module("imApp").factory("metaTableMenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMetaTableMenu: function (parms) {
                return $ihttp.post({
                    method: 2375,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
